import { Activity, useEffect, useRef, useState } from 'react';

// material-ui
import IconButton from '@mui/material/IconButton';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Box from '@mui/material/Box';

// project imports
import LocalizationSection from '../LocalizationSection';
import Transitions from 'ui-component/extended/Transitions';

// assets
import { IconDotsVertical } from '@tabler/icons-react';

// ==============================|| MOBILE HEADER ||============================== //

export default function MobileSection() {
  const [open, setOpen] = useState(false);

  /**
   * anchorRef is used on different componets and specifying one type leads to other components throwing an error
   * */
  const anchorRef = useRef<any>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <>
      <Box component="span" ref={anchorRef} sx={{ mt: 1, ml: 1 }}>
        <IconButton sx={{ color: 'text.primary', ml: 0.5, cursor: 'pointer' }} onClick={handleToggle}>
          <IconDotsVertical
            stroke={1.5}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            style={{ fontSize: '1.5rem' }}
          />
        </IconButton>
      </Box>

      {/* ZERCODE CHANGE [STD-FE] - HEADER-MENU-PHONE: this menu rendered as a detached white strip across
          the whole width of the page holding one lone language button, because Berry nests an `<AppBar>`
          INSIDE the popper - and MUI's AppBar defaults to `position: fixed`.

          Measured at 375px: the Paper collapsed to 375x0, because its only child was out of flow, and the
          AppBar floated separately at 375x84 with `z-index: 1100` - the same layer as the real header. So
          it was not anchored to the button that opened it, had no surface behind it, and did not move with
          the page. It read as a second header rather than as a menu.

          A popover's contents are a row of controls, so that is what they are now. Measured after: the
          Paper is 56x56, in flow, under the button. The popper's `width: '100%'` went with the AppBar - it
          only ever existed to host a full-width bar - and `zIndex: 1` went with it, since the fixed child
          was escaping that stacking context anyway. */}
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        style={{ zIndex: 1200 }}
        modifiers={[
          {
            name: 'offset',
            options: {
              offset: [0, 8]
            }
          },
          {
            name: 'preventOverflow',
            options: {
              padding: 16
            }
          }
        ]}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClose}>
            <Transitions type="zoom" in={open} {...TransitionProps} sx={{ transformOrigin: 'top right' }}>
              <Paper sx={{ maxWidth: 'calc(100vw - 32px)' }}>
                <Activity mode={open ? 'visible' : 'hidden'}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1 }}>
                    <LocalizationSection />
                  </Box>
                </Activity>
              </Paper>
            </Transitions>
          </ClickAwayListener>
        )}
      </Popper>
    </>
  );
}
